<template>
  <v-list
    two-line
    subheader
  >
    <v-list-tile
      avatar
      @click="$router.push({name: 'home'})"
    >
      <v-list-tile-avatar>
        <v-icon>map</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-text="'Home'"/>
      </v-list-tile-content>
    </v-list-tile>
    <v-subheader inset>{{ strollWording|capitalize }}</v-subheader>
    <v-list-tile
      v-for="stroll of sortedStrolls"
      :key="stroll.id"
      avatar
      @click="$router.push({name: 'stroll', params: {strollId: stroll.id}})"
    >
      <stroll-avatar :stroll="stroll" />
      <v-list-tile-content>
        <v-list-tile-title v-text="stroll.title" />
        <v-list-tile-sub-title v-text="stroll.description_text" />
        <v-list-tile-sub-title v-if="location.timestamp && stroll.point">
          <v-icon class="icon-sm grey--text">my_location</v-icon>
          {{ stroll.distance|distance }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import { calculateDistanceBetweenCoordinates } from '@/utils/distanceUtils'
import StrollAvatar from '@/components/StrollAvatar.vue'

export default {
  name: 'StrollNavigationList',

  components: {
    StrollAvatar,
  },

  props: {
    strolls: Array,
  },

  data() {
    return {
      strollDistances: {}
    }
  },

  computed: {
    ...mapGetters({
      location: 'getLocation',
      strollWording: 'getStrollWording',
    }),

    sortedStrolls() {
      if (!this.strollDistances) {
        return this.strolls
      }
      const strollsCopy = []
      this.strolls.forEach(stroll => strollsCopy.push({...stroll, distance: this.getDistanceToStroll(stroll)}))
      const sortedStrolls = strollsCopy.sort((a, b) => {
        return a.distance - b.distance
      })
      return sortedStrolls
    }
  },

  methods: {
    getDistanceToStroll(stroll) {
      const strollCoordinates = stroll.point.coordinates
      const userCoordinates = [this.location.latitude, this.location.longitude]
      const distance = calculateDistanceBetweenCoordinates(userCoordinates, strollCoordinates)
      return distance
    }
  },

}
</script>

<style>
.icon-sm {
  font-size: 1.2em !important;
}
</style>
